import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeGoogleAnalytics extends ChangeBusinessDetails {
  type: string = 'ChangeGoogleAnalytics';
}
